import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

/**
 * DP94 Part 1 — A GATEWAY MASTHEAD RENDERS THROUGH THE SHELL'S OWN SLOT.
 *
 * The band has to be a SIBLING of .km-panel, above it, to span the whole
 * content region: a negative margin cannot reach past a centred max-width box,
 * which is what DP93 found and stopped on.
 *
 * One slot on AppShell rather than three pages each rendering the band above
 * {children}: one place to change, and the two bands that are built deep inside
 * their page stay where the data that feeds them is computed. All Projects'
 * figures are built inside the render that has the lists; hoisting the markup
 * out would have meant hoisting that computation with it.
 */
export const ShellMasthead = ({ children }) => {
  const [host, setHost] = useState(null);
  useEffect(() => {
    // The shell renders the slot before a page's children mount, so one look is
    // normally enough. If a future route ever mounts a band first, keep looking
    // for a few frames rather than rendering nothing in silence.
    let tries = 0, raf = 0;
    const look = () => {
      const el = document.getElementById('km-shell-mast');
      if (el) { setHost(el); return; }
      if (++tries > 20) {
        console.warn('[ShellMasthead] no #km-shell-mast slot — the band is not rendered');
        return;
      }
      raf = requestAnimationFrame(look);
    };
    look();
    return () => cancelAnimationFrame(raf);
  }, []);
  return host ? createPortal(children, host) : null;
};

export default ShellMasthead;
